export default "__VITE_ASSET__DAb3wU$u__"